import $ from 'jquery';

export const scrollFromFooterOnFocus = (footerHeight, inputs = 'input, button, a, select') => {
  $(inputs).focus(function () {
    const $element = $(this);

    if ($element.offset().top - $(window).scrollTop() > $(window).height() - footerHeight) {
      $('html, body').animate(
        {
          scrollTop: $element.offset().top - ($(window).height() - footerHeight),
        },
        500
      );
    }
  });
};

export const scrollFromHeaderOnFocus = (headerHeight, inputs = 'input, button, a, select') => {
  $(inputs).focus(function () {
    const $element = $(this);

    if ($element.offset().top - $(window).scrollTop() < headerHeight) {
      $('html, body').animate(
        {
          scrollTop: $element.offset().top - headerHeight,
        },
        500
      );
    }
  });
};
